export const LAT_LONG = 'latlong';
export const COUNTRY = 'country';
export const STATE = 'state';
export const CITY = 'city';
export const COUNTY = 'county';
export const DMA = 'dma';
export const CLUSTER = 'cluster';
export const BOUNDARY = 'boundary';
export const CONGRESSIONAL_DISTRICT = 'congressional_district';
export const ZIP_CODE = 'zipcode';
export const TOP_LEFT = 'top-left';
export const BLUE = 'blue';
export const SYMBOL = 'symbol';
export const MOVEEND = 'moveend';
export const CLICK = 'click';
export const NA = 'N/A';
export const MIN_ZOOM = 'MIN_ZOOM';
export const FIELDS = 'FIELDS';

export const SOURCE_LAYER = 'SOURCE_LAYER';
export const WEBKITFULLSCREENCHANGE = 'webkitfullscreenchange';
export const FULLSCREENCHANGE = 'fullscreenchange';
export const MOZFULLSCREENCHANGE = 'mozfullscreenchange';

export const MAPBOX_MAP_STYLES = {
  STREET: 'mapbox://styles/mapbox/streets-v12',
  OUTDOOR: 'mapbox://styles/mapbox/outdoors-v12',
  LIGHT: 'mapbox://styles/mapbox/light-v11',
  DARK: 'mapbox://styles/mapbox/dark-v11',
  SATELLITE: 'mapbox://styles/mapbox/satellite-v9',
  SATELLITE_STREET: 'mapbox://styles/mapbox/satellite-streets-v12',
  NAVIGATION_DAY: 'mapbox://styles/mapbox/navigation-day-v1',
  NAVIGATION_NIGHT: 'mapbox://styles/mapbox/navigation-night-v1',
};
export const MAPBOX_DATE_DISPLAY_FORMAT = 'MMM dd, yyyy';
export const INVALID_GEO_CONFIG_VALUES = [
  null,
  undefined,
  '00',
  '0',
  '',
  '-',
  '--',
  String(undefined),
  String(null),
];
export const GeoJsonType = {
  FEATURE: 'Feature',
  FEATURE_COLLECTION: 'FeatureCollection',
  POINT: 'Point',
  LINE_STRING: 'LineString',
  POLYGON: 'Polygon',
  MULTI_POLYGON: 'MultiPolygon',
  MULTI_LINE_STRING: 'MultiLineString',
};
export const GeoJsonCrs = {
  TYPE: 'name',
  CRS84: 'urn:ogc:def:crs:OGC:1.3:CRS84',
};
export const MAPBOX_MAP_EVENTS = {
  LOAD: 'load',
  ZOOM: 'zoom',
  IDLE: 'idle',
  MOUSE_ENTER: 'mouseenter',
  MOUSE_MOVE: 'mousemove',
  MOUSE_LEAVE: 'mouseleave',
  SOURCE_DATA: 'sourcedata',
  STYLE_DATA: 'styledata',
};

export const Countries = {
  US: 'US',
  USA: 'USA',
};
export const MAP_BOUNDARY = [
  [-180, -90],
  [180, 90],
];

export const MAPBOX_PROJECTION = {
  MERCATOR: 'mercator',
};
export const MAPBOX_IMAGE_FORMAT = {
  PNG: 'image/png',
  JPEG: 'image/jpeg',
};
export const MAPBOX_MAP_ID_PREFIX = 'map-';
export const MAPBOX_WATCH_KEYS = {
  LAYERS: 'widget.metadata.draw_options.layers',
  HIDE_ZERO_VALUE: 'widget.metadata.draw_options.hide_zero_value',
  MAP_GEOGRAPHIC_FEATURES: 'widget.metadata.draw_options.map_geographic_features',
  GEO_LAYER_OPACITY: 'widget.metadata.draw_options.geo_layer_opacity',
  AUTO_ZOOM: 'widget.metadata.draw_options.auto_zoom',
  AUTO_ZOOM_THRESHOLD: 'widget.metadata.draw_options.auto_zoom_threshold',
  WIDGET_WIDTH: 'widget.width',
  WIDGET_HEIGHT: 'widget.height',
  PANEL_VISIBILITY: 'state.isShowing',
};
export const MAPBOX_LAYERS_METADATA = {
  [COUNTRY]: {
    SOURCE_LAYER: 'country_boundaries',
    FIELDS: ['name', 'iso_3166_1', 'iso_3166_1_alpha_3'],
    SOURCE_KEY_PREFIX: 'countrysource',
    LAYER_KEY_PREFIX: 'countrylayer',
    MIN_ZOOM: 0.1,
  },
  [STATE]: {
    SOURCE_LAYER: 'tl_rd22_us_state-2qpq3k',
    FIELDS: ['NAME', 'STUSPS'],
    SOURCE_KEY_PREFIX: 'statesource',
    LAYER_KEY_PREFIX: 'statelayer',
    MIN_ZOOM: 2.1,
  },
  [CITY]: {
    SOURCE_LAYER: 'cb_2022_us_place_500k-52iz77',
    FIELDS: ['NAME', 'STUSPS', 'NAMELSAD'],
    SOURCE_KEY_PREFIX: 'citysource',
    LAYER_KEY_PREFIX: 'citylayer',
    MIN_ZOOM: 3.1,
  },
  [ZIP_CODE]: {
    SOURCE_LAYER: 'cb_2020_us_zcta520_500k-a84xva',
    FIELDS: ['NAME20'],
    SOURCE_KEY_PREFIX: 'ziplinesource',
    LAYER_KEY_PREFIX: 'ziplinelayer',
    MIN_ZOOM: 4.1,
  },
  [DMA]: {
    SOURCE_LAYER: 'new_dma-9hgg7m',
    FIELDS: ['NAME', 'Key'],
    SOURCE_KEY_PREFIX: 'dmasource',
    LAYER_KEY_PREFIX: 'dmalayer',
    MIN_ZOOM: 0.1,
  },
  [CONGRESSIONAL_DISTRICT]: {
    SOURCE_LAYER: 'cb_2022_us_cd118_500k-dbmhqv',
    FIELDS: ['NAMELSAD', 'STATEFP'],
    SOURCE_KEY_PREFIX: 'congressionaldistrictsource',
    LAYER_KEY_PREFIX: 'congressionaldistrictlayer',
    MIN_ZOOM: 2.1,
  },
};
export const $MapBoxEvents = {
  LAYER_UPDATE: '$MapBoxEvents:LAYER_UPDATE',
};
export const LAYERS_PRIORITY = {
  [LAT_LONG]: 0,
  [COUNTRY]: 1,
  [STATE]: 2,
  [COUNTY]: 3,
  [CITY]: 4,
  [ZIP_CODE]: 5,
  [DMA]: 6,
  [CONGRESSIONAL_DISTRICT]: 7,
};

export const MAPBOX_SERVICE_IDS = {
  ADOBE_SERVICE_ID: '200',
  THE_TRADE_DESK_ID: '61',
  FACEBOOK_ADS_ID: '39',
  CAMPAIGN_MANAGER_360_ID: '200',
  DFP_ID: '56',
  DFA_ID: '51',
};

export const MAPBOX_LAYERS = {
  LAT_LONG_CLUSTER_LAYER: 'latLongClusterLayer',
  LAT_LONG_CLUSTER_COUNT_LAYER: 'latLongClusterCountLayer',
  LAT_LONG_METRIC_UNCLUSTER_LAYER: 'latLongMetricUnClusterLayer',
  LAT_LONG_METRIC_CLUSTER_COUNT_LAYER: 'latLongMetricClusterCountLayer',
  LAT_LONG_METRIC_CLUSTER_CIRCLE_LAYER: 'latLongMetricClusterCircleLayer',
};

export const STATE_LAT_LONG = {
  AK: { geo_latitude: 63.588753, geo_longitude: -154.493062 },
  AL: { geo_latitude: 32.318231, geo_longitude: -86.902298 },
  AR: { geo_latitude: 35.20105, geo_longitude: -91.831833 },
  AZ: { geo_latitude: 34.048928, geo_longitude: -111.093731 },
  CA: { geo_latitude: 36.778261, geo_longitude: -119.417932 },
  CO: { geo_latitude: 39.550051, geo_longitude: -105.782067 },
  CT: { geo_latitude: 41.603221, geo_longitude: -73.087749 },
  DC: { geo_latitude: 38.905985, geo_longitude: -77.033418 },
  DE: { geo_latitude: 38.910832, geo_longitude: -75.52767 },
  FL: { geo_latitude: 27.664827, geo_longitude: -81.515754 },
  GA: { geo_latitude: 32.157435, geo_longitude: -82.907123 },
  HI: { geo_latitude: 19.898682, geo_longitude: -155.665857 },
  IA: { geo_latitude: 41.878003, geo_longitude: -93.097702 },
  ID: { geo_latitude: 44.068202, geo_longitude: -114.742041 },
  IL: { geo_latitude: 40.633125, geo_longitude: -89.398528 },
  IN: { geo_latitude: 40.551217, geo_longitude: -85.602364 },
  KS: { geo_latitude: 39.011902, geo_longitude: -98.484246 },
  KY: { geo_latitude: 37.839333, geo_longitude: -84.270018 },
  LA: { geo_latitude: 31.244823, geo_longitude: -92.145024 },
  MA: { geo_latitude: 42.407211, geo_longitude: -71.382437 },
  MD: { geo_latitude: 39.045755, geo_longitude: -76.641271 },
  ME: { geo_latitude: 45.253783, geo_longitude: -69.445469 },
  MI: { geo_latitude: 44.314844, geo_longitude: -85.602364 },
  MN: { geo_latitude: 46.729553, geo_longitude: -94.6859 },
  MO: { geo_latitude: 37.964253, geo_longitude: -91.831833 },
  MS: { geo_latitude: 32.354668, geo_longitude: -89.398528 },
  MT: { geo_latitude: 46.879682, geo_longitude: -110.362566 },
  NC: { geo_latitude: 35.759573, geo_longitude: -79.0193 },
  ND: { geo_latitude: 47.551493, geo_longitude: -101.002012 },
  NE: { geo_latitude: 41.492537, geo_longitude: -99.901813 },
  NH: { geo_latitude: 43.193852, geo_longitude: -71.572395 },
  NJ: { geo_latitude: 40.058324, geo_longitude: -74.405661 },
  NM: { geo_latitude: 34.97273, geo_longitude: -105.032363 },
  NV: { geo_latitude: 38.80261, geo_longitude: -116.419389 },
  NY: { geo_latitude: 43.299428, geo_longitude: -74.217933 },
  OH: { geo_latitude: 40.417287, geo_longitude: -82.907123 },
  OK: { geo_latitude: 35.007752, geo_longitude: -97.092877 },
  OR: { geo_latitude: 43.804133, geo_longitude: -120.554201 },
  PA: { geo_latitude: 41.203322, geo_longitude: -77.194525 },
  PR: { geo_latitude: 18.220833, geo_longitude: -66.590149 },
  RI: { geo_latitude: 41.580095, geo_longitude: -71.477429 },
  SC: { geo_latitude: 33.836081, geo_longitude: -81.163725 },
  SD: { geo_latitude: 43.969515, geo_longitude: -99.901813 },
  TN: { geo_latitude: 35.517491, geo_longitude: -86.580447 },
  TX: { geo_latitude: 31.968599, geo_longitude: -99.901813 },
  UT: { geo_latitude: 39.32098, geo_longitude: -111.093731 },
  VA: { geo_latitude: 37.431573, geo_longitude: -78.656894 },
  VT: { geo_latitude: 44.558803, geo_longitude: -72.577841 },
  WA: { geo_latitude: 47.751074, geo_longitude: -120.740139 },
  WI: { geo_latitude: 43.78444, geo_longitude: -88.787868 },
  WV: { geo_latitude: 38.597626, geo_longitude: -80.454903 },
  WY: { geo_latitude: 43.075968, geo_longitude: -107.290284 },
};

export const US_COUNTRY_MAPPER = {
  STATE_3CODE_TO_ISO: {
    ALA: 'AL',
    AKS: 'AK',
    ARZ: 'AZ',
    ARK: 'AR',
    CAL: 'CA',
    COL: 'CO',
    CON: 'CT',
    DEL: 'DE',
    FLA: 'FL',
    GEO: 'GA',
    HAW: 'HI',
    IDA: 'ID',
    ILL: 'IL',
    IND: 'IN',
    IOW: 'IA',
    KAN: 'KS',
    KYT: 'KY',
    LOU: 'LA',
    MAI: 'ME',
    MAR: 'MD',
    MAS: 'MA',
    MIC: 'MI',
    MIN: 'MN',
    MIS: 'MS',
    MOC: 'MO',
    MON: 'MT',
    NEB: 'NE',
    NEV: 'NV',
    NHP: 'NH',
    NEW: 'NJ',
    NMX: 'NM',
    NYK: 'NY',
    NCC: 'NC',
    NDK: 'ND',
    OHI: 'OH',
    OKL: 'OK',
    ORE: 'OR',
    PEN: 'PA',
    RHO: 'RI',
    SCC: 'SC',
    SDK: 'SD',
    TEN: 'TN',
    TEX: 'TX',
    UTA: 'UT',
    VER: 'VT',
    VIR: 'VA',
    WAS: 'WA',
    WVK: 'WV',
    WIS: 'WI',
    WYO: 'WY',
    DC: 'DC',
  },
};
